<template>
  <main class="external-login">
    <iframe
      class="external-login__frame"
      :src="searchKitUrl"
      title="Search Connect sign in"
    ></iframe>
  </main>
</template>

<script setup>
const searchKitUrl = new URL('/login', process.env.VUE_APP_SEARCH_KIT_URL).toString()
</script>

<style scoped>
.external-login {
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.external-login__frame {
  display: block;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
  border: 0;
}
</style>
